import React from "react";
import Tabs from "../../components/tab";
import {Link} from "react-router-dom";
import Input from "../../components/inputItem";
import useForm from "rc-form-hooks";

let tabs = ['邮箱注册'];

function Register() {
    const {getFieldDecorator, validateFields, errors, values} = useForm<{
        email: string,
        password: string,
        confirm:string
    }>();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        validateFields()
            .then(console.log)
            .catch(e => console.error(e.message));
    };


    return <div className="login">
        <div className="login-box">
            <Tabs tabs={tabs} mask={false} onChange={(index) => void(0) }/>

            <div className="section">
                <form onSubmit={handleSubmit}>
                    {
                        getFieldDecorator('email', {
                            rules: [{required: true, message: '请输入邮箱账号'}]
                        })(<Input label='邮&nbsp;&nbsp;箱' placeholder='请输入邮箱账号'
                                  extraClass={['no-border-top', 'fill-width']}  clear/>)
                    }
                    {
                        getFieldDecorator('password', {
                            rules: [{required: true, message: '请输入密码'}]
                        })(<Input label='密&nbsp;&nbsp;码' placeholder='请输入密码' type={'password'} extraClass={['no-border-top', 'fill-width']}
                                  clear/>)
                    }
                    {
                        getFieldDecorator('confirm', {
                            rules: [{required: true, message: '请再次输入密码'}]
                        })(<Input label='确&nbsp;&nbsp;认' placeholder='请再次输入密码' type={'password'} extraClass={['no-border-top', 'fill-width']}
                                  clear/>)
                    }
                    <button type={'submit'} className="common-btn submit">登录</button>
                </form>
            </div>

            <div className="tip">
                <Link to={'/'}>国内用户试试手机登录 <span style={{fontSize:'12px'}} className='iconfont'>&#xe608;</span> </Link>
            </div>

        </div>
    </div>
}

export default Register
